import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/layout/Layout'
import Login from './pages/auth/Login'
import Register from './pages/auth/Register'
import Dashboard from './pages/dashboard/Dashboard'
import TransactionList from './pages/transactions/TransactionList'
import Reconciliation from './pages/reconciliation/Reconciliation'
import ProfitLoss from './pages/reports/ProfitLoss'
import BalanceSheet from './pages/reports/BalanceSheet'
import SeedData from './pages/demo/SeedData'
import Settings from './pages/settings/Settings'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  return <>{children}</>
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Protected routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="transactions" element={<TransactionList />} />
          <Route path="reconciliation" element={<Reconciliation />} />
          <Route path="reports/pnl" element={<ProfitLoss />} />
          <Route path="reports/balance-sheet" element={<BalanceSheet />} />
          <Route path="demo" element={<SeedData />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
